import { useMutation } from 'react-query';
import { BASE_URL } from '../configs/config';
import Auth from '../libs/auth-wrapper';
import { apiFetch } from '../libs/apiFetch';

interface RefundParams {
  chargeId: string;
  amount: number;
  reason?: string;
  stadiumID: string;
}

const useCreateRefund = () => {
  return useMutation(async ({ chargeId, amount, reason, stadiumID }: RefundParams) => {
    if (!chargeId || !amount || !stadiumID) {
      throw new Error('Missing required fields');
    }

    const idToken = await Auth.getIdToken();

    const response = await apiFetch(`${BASE_URL}createRefund`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
      body: JSON.stringify({ chargeId, amount, reason, stadiumID }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.error || 'Failed to create refund');
    }

    return response.json();
  });
};

export default useCreateRefund;
